// extracted by mini-css-extract-plugin
export default {"-large":"VClKpqCqFXZ2sXAE9SUJ","dottedButtonContainer":"Y6yjtjMT6FoZ3KM1L2Yk","premiumIcon":"EQU1XhARbnWBDlX48MaC","maxWidth":"FLLl7HMG6nyjP1WJ4Rnj"};